import React from "react";
import { Fraud } from "../../generated/graphql";

export type FraudNoticeProps = {
    fraud: Fraud
}

const FraudNotice = (props: FraudNoticeProps) => {
    const fraud = props.fraud
    return <div style={findStateStyleFor(fraud)}>
        {findFraudSummaryFor(fraud)}
    </div>
}

function findStateStyleFor(fraud: Fraud) {
    return { fontWeight: fraud.bold ? 'bold' : 'normal', fontSize: `${fraud.fontSize}pt` };
}

function findFraudSummaryFor(fraud: Fraud) {
    return `${fraud.state}: ${fraud.text}`;
}

export default FraudNotice;
